import React from "react";
import './EducationBox.scss';
import Typography from '@mui/material/Typography';

const EducationBox = ({ education }) => {

    return (
        <div className="education-box text-center">

            <i className="fas fa-graduation-cap education-icon"></i>

            <Typography variant="h6" gutterBottom component="div" className="">
                {education.degree}
            </Typography>

            <Typography variant="subtitle2" gutterBottom component="div" className="">
                {education.name}
            </Typography>

            <Typography variant="overline" gutterBottom component="div" className="">
                {education.year}, {education.grade}
            </Typography>

            <Typography variant="body2" gutterBottom className="">
                {education.description}
            </Typography>

        </div>
    );
}

export default EducationBox;
